<script>
import { Icon } from 'svelte-icons-pack';
import { BiDollar } from "svelte-icons-pack/bi";
// import  Tooltip  from './Tooltip.svelte';

export let dailyReport;

$: netliqs = dailyReport.map((report) => report.netliq);
$: ethValues = dailyReport.map((report) => report.eth_price);

function getReturns(initial, final) {
  if (initial === 0) { // to avoid division by zero
    return 0;
  }
  return (final - initial) / initial * 100;
}

function getExcessReturns(netliqReturns, ethReturns) {
  return netliqReturns - ethReturns;
}

$: excessReturns = getExcessReturns(getReturns(netliqs[0], netliqs[netliqs.length-1]), 
  getReturns(ethValues[0], ethValues[ethValues.length-1]));
</script>

<h6>
  <Icon src={BiDollar} size="20" color="CornflowerBlue"/>
  Excess Return
</h6>

<div style="font-size: 20px; display: inline; color: {excessReturns > 0 ? "green" : "red"};">
    {isNaN(excessReturns) ? 0 : excessReturns.toFixed(2)}%
</div>
<br>


